import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { API, useAuth } from "@/lib/auth";

export default function MagicLink() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [error, setError] = useState(null);
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    if (!token) { navigate("/"); return; }
    (async () => {
      try {
        await axios.post(`${API}/auth/magic`, { token });
        await refresh();
        toast.success("Welcome back — you're signed in.");
        navigate("/account", { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || "This link is no longer valid.");
      }
    })();
  }, [token, navigate, refresh]);

  return (
    <div
      data-testid="page-magic-link"
      className="min-h-screen flex items-center justify-center bg-cream"
    >
      <div className="text-center max-w-md px-6">
        {error ? (
          <>
            <div className="overline">Link expired</div>
            <h1 className="font-display text-4xl mt-3 tracking-tight">
              This link is no longer valid.
            </h1>
            <p className="mt-4 text-[hsl(var(--onyx)/0.6)]">{error}</p>
            <button
              onClick={() => navigate("/")}
              className="btn-pill btn-primary mt-6"
            >
              Back to home
            </button>
          </>
        ) : (
          <>
            <Loader2 size={32} className="animate-spin mx-auto text-[hsl(var(--gold))]" />
            <div className="overline mt-6">Signing you in</div>
            <h1 className="font-display text-4xl mt-3 tracking-tight">
              One moment…
            </h1>
          </>
        )}
      </div>
    </div>
  );
}
